import { render } from "./trades.vue?vue&type=template&id=5898b8ed"
import script from "./trades.vue?vue&type=script&lang=js"
export * from "./trades.vue?vue&type=script&lang=js"

import "./trades.vue?vue&type=style&index=0&id=5898b8ed&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__